import { Badge } from '@shopify/polaris';
import { ENUM_TRANSACTION_PAYMENT_METHOD } from 'queries/transactions.query';
import { ENUM_ORDER_PAYMENT_STATUS } from 'queries/orders.query';
import { TypedTransactions } from 'queries/transactions.query';

export function getLatestOrderTransaction(transactions?: TypedTransactions[]) {
  return transactions?.length ? transactions[transactions.length - 1] : undefined;
}

export function getOrderPaymentStatus(status?: ENUM_ORDER_PAYMENT_STATUS) {
  switch (status) {
    case ENUM_ORDER_PAYMENT_STATUS.PAID:
      return <Badge tone="success">ĐÃ THANH TOÁN</Badge>;
    case ENUM_ORDER_PAYMENT_STATUS.PARTIALLY_PAID:
      return <Badge tone="attention">THANH TOÁN MỘT PHẦN</Badge>;
    default:
      return <Badge tone="critical">CHƯA THANH TOÁN</Badge>;
  }
}

export function getOrderStatus(status: any) {
  switch (status) {
    case 9:
      return <Badge tone={'read-only'}>ĐƠN ĐÃ HỦY</Badge>;
    case 0:
      return <Badge tone={'read-only'}>ĐƠN NHÁP</Badge>;
    case 1:
      return <Badge tone={'info'}>ĐÃ XẾP CHUYẾN</Badge>;
    case 2:
      return <Badge tone={'critical'}>TRONG CHUYẾN</Badge>;
    case 3:
      return <Badge tone={'success'}>HOÀN THÀNH</Badge>;
  }
}

export function getOrderDebitStatus(status: ENUM_TRANSACTION_PAYMENT_METHOD) {
  switch (status) {
    case ENUM_TRANSACTION_PAYMENT_METHOD.DEBT_CUSTOMER:
      return <Badge tone="critical-strong">CÔNG NỢ KHÁCH</Badge>;
    case ENUM_TRANSACTION_PAYMENT_METHOD.DEBT_AGENT:
      return <Badge tone="critical-strong">CÔNG NỢ ĐẠI LÝ</Badge>;
    case ENUM_TRANSACTION_PAYMENT_METHOD.THIRD_PARTY:
      return <Badge tone="critical-strong">CÔNG NỢ BÊN T.BA</Badge>;
    default:
      return null;
  }
}
